/* eslint-disable camelcase */
export const sanitizeCalculationForCreate = (calculation, pricingRuleId: number, sort: number) => ({
  pricing_rule_id: pricingRuleId,
  is_active: Boolean(calculation?.is_active),
  sort,
  uses_all_conditions: Boolean(calculation?.uses_all_conditions),
  should_stop_calculations: Boolean(calculation?.should_stop_calculations),
  pricing_actions: (calculation?.pricing_actions ?? []).map(action => ({
    data_point_id_1: action?.data_point_id_1 ?? null,
    data_point_id_2: action?.data_point_id_2 ?? null,
    data_point_id_3: action?.data_point_id_3 ?? null,
    operator: action?.operator ?? null,
    value: action?.value ?? null,
  })),
  pricing_conditions: (calculation?.pricing_conditions ?? []).map(condition => ({
    data_point_id: condition?.data_point_id ?? null,
    operator: condition?.operator ?? null,
    value_1: condition?.value_1 ?? null,
    value_2: condition?.value_2 ?? null,
    data_point_id_2: condition?.data_point_id_2 ?? null,
  })),
});
